import api from "@/services/utils/apiInstance.ts";

import type { DashboardProductManufacturerActiveCountsResponse } from "@/types/services/dashboardStatistics.type.ts";

class DashboardStatisticsService {
  async getProductManufacturerActiveCounts(): Promise<DashboardProductManufacturerActiveCountsResponse> {
    const response =
      await api.get<DashboardProductManufacturerActiveCountsResponse>(
        "/common/statistics/product-manufacturer/active-counts",
      );
    return response.data;
  }
}

export default new DashboardStatisticsService();
